export default "__VITE_ASSET__ksSS6fcm__"